import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuthContext } from 'auth/AuthContext';
import React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import LoggedOutContent from '../LoggedOutContent';
import SecuredContent from '../SecuredContent';

const CustomToggle = React.forwardRef(
  (
    { children, onClick }: { children?: React.ReactNode; onClick?: any },
    ref: any,
  ) => (
    <Button
      ref={ref}
      variant="link"
      className="menu-toggle"
      onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </Button>
  ),
);

const CustomMenu = React.forwardRef(
  (
    { style, className, 'aria-labelledby': labeledBy, close }: any,
    ref: any,
  ) => {
    const { logout } = useAuthContext();

    return (
      <div
        ref={ref}
        style={style}
        className={`menu ${className}`}
        aria-labelledby={labeledBy}
      >
        <div className="menu-logo"></div>

        <LoggedOutContent>
          <ul className="list-unstyled">
            <li>
              <Link to="/login" onClick={close}>
                Login
              </Link>{' '}
              <span className="arrow" />
            </li>
          </ul>
        </LoggedOutContent>

        <SecuredContent>
          <ul className="list-unstyled">
            <li>
              <Link to="/" onClick={close}>
                MAIN
              </Link>{' '}
              <span className="arrow" />
            </li>
          </ul>

          <SecuredContent role={process.env.REACT_APP_REVIEWER_ROLE_NAME}>
            <ul className={`list-unstyled titled`}>
              <li className="mb-2">
                <Link to="/review" onClick={close}>
                  Review Journal Entries <span className="arrow" />
                </Link>
              </li>
              <li>
                <Link to="/status-report" onClick={close}>
                  Status Report <span className="arrow" />
                </Link>
              </li>
            </ul>
          </SecuredContent>

          <SecuredContent role={process.env.REACT_APP_ADMIN_ROLE_NAME}>
            <ul className={`list-unstyled titled`}>
              <li className="mb-2">
                <Link to="/master-checklist" onClick={close}>
                  Master Checklist <span className="arrow" />
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/monthly-checklist" onClick={close}>
                  Monthly Checklist <span className="arrow" />
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/bulk-update" onClick={close}>
                  Bulk Update <span className="arrow" />
                </Link>
              </li>
            </ul>
          </SecuredContent>

          <ul className={`list-unstyled titled`}>
            <li>
              <Button variant="link" className="pl-0" onClick={logout}>
                Logout
              </Button>
            </li>
          </ul>
        </SecuredContent>
      </div>
    );
  },
);

export const MenuDropdown = (): JSX.Element => {
  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id="main-dropdown-menu">
        <span>
          <FontAwesomeIcon icon={faBars} /> Menu
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu as={CustomMenu}></Dropdown.Menu>
    </Dropdown>
  );
};

export default MenuDropdown;
